import { Logout } from "@/auth";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/logout",
)({
  component: Logout,
});
